import * as R from 'ramda';

export const mergeConnectedBooking = (prevBookings, newBookings) => R.uniqBy(
  R.prop('id'),
  R.concat(prevBookings, newBookings)
);
